import { Button } from 'core-components/library/button'
import { Loader } from 'core-components/library/loader'
import { TRevenueCriteriaThresholds } from 'onboarding/components/widgets/public/admin/eligibilityCriteria/models'

import { RevenueCriteria } from '../../revenueCriteria/RevenueCriteria'
import { IViewCriteriaProps, ViewCriteria } from '../../viewCriteria/ViewCriteria'
import { ViewAllCriteria } from '../ViewAllCriteria'
import stylesViewAllCriteria from '../ViewAllCriteria.module.scss'

import styles from './ViewAllCriteriaModal.module.scss'

export interface IViewAllCriteriaModalProps extends IViewCriteriaProps {
  specializationName: string
  thresholds: TRevenueCriteriaThresholds | undefined
  isLoading?: boolean
  onClose: () => void
}

export const ViewAllCriteriaModal = ({
  specializationName,
  content,
  thresholds,
  isLoading,
  onClose,
}: IViewAllCriteriaModalProps) => {
  return (
    <div className={styles.container}>
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <div className={stylesViewAllCriteria.bottomWrapper}>
            <ViewAllCriteria
              specializationName={specializationName}
              requirementsCriteria={<ViewCriteria content={content} />}
              thresholdsCriteria={
                thresholds ? <RevenueCriteria thresholds={thresholds} /> : undefined
              }
            />
          </div>
          <Button onClick={onClose}>Ok</Button>
        </>
      )}
    </div>
  )
}
